import request from '../utils/http'

const Scoreapis = {
    //查询银行列表
    getScoreList : query => {
        return request({
            url: '/score/getScoreList',
            method: 'get',
            params:query
        });
    },
     //查看银行详情
     getScoreById : query => {
        return request({
            url: '/score/getScoreById',
            method: 'get',
            params: query
        });
    },
     //新增银行
     addScore : query => {
        return request({
            url: '/score/addScore',
            method: 'post',
            data: query
        });
    },
     //修改银行
     updateScore : query => {
        return request({
            url: '/score/updateScore',
            method: 'post',
            data: query
        });
    },
    updateOnlineApply: query => {
        return request({
            url: '/score/updateOnlineApply',
            method: 'post',
            data: query
        });
    },
      //删除银行
      deleteScore : query => {
        return request({
            url: '/score/deleteScore',
            method: 'post',
            params: query
        });
    },
         //查看担保详情
         getBookByCode : query => {
            return request({
                url: '/standingBook/getBookByCode',
                method: 'get',
                params: query
            });
        },
         //查询银行列表
         getApplyOnlineList : query => {
        return request({
            url: '/score/getApplyOnlineList',
            method: 'get',
            params:query
        });
      },
      getapplyOnlineById : query => {
        return request({
            url: '/score/getapplyOnlineById',
            method: 'get',
            params:query
        });
    },
}


export default Scoreapis
